import { SelectLang as UmiSelectLang } from '@umijs/max';
import React, { useState, useEffect } from 'react';
import ReportTask from '../ReportTask';
import { getMessageUnreadCount, markAllMessagesAsRead } from '@/services/ant-design-pro/api';
import progressIcon from '@/assets/icons/progress.svg';
import messageCenterIcon from '@/assets/icons/message-center.svg';
import MessageCenter from '../messageCenter/MessageCenter';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const ProgressTip = () => {
  const [messageCenterOpen, setMessageCenterOpen] = useState(false);
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
    >
      <img
        src={progressIcon}
        alt="progress"
        style={{ width: 18, height: 18, cursor: 'pointer' }}
        onClick={() => {
          setMessageCenterOpen(true);
        }}
      />
      {messageCenterOpen && (
        <ReportTask
          open={messageCenterOpen}
          handleClose={() => {
            setMessageCenterOpen(false);
          }}
        />
      )}
    </div>
  );
};

export const ProgressTip1 = () => {
  const [messageCenterOpen, setMessageCenterOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const isDev = process.env.NODE_ENV === 'development';

  useEffect(() => {
    console.log('msgCenter unreadCount', unreadCount);
    // if (isDev) {
    //   return;
    // }
    const fetchUnreadCount = async () => {
      try {
        let response = await getMessageUnreadCount();
        // setUnreadCount(23);
        setUnreadCount(response?.data?.count || 0);
      } catch (error) {
        // ignore in production to avoid noisy logs
      }
    };

    fetchUnreadCount();
    // 可以添加定时器定期刷新未读数量
    const interval = setInterval(fetchUnreadCount, 60000); // 每分钟刷新一次
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        height: 26,
        position: 'relative',
        marginBottom: 4,
      }}
    >
      <img
        src={messageCenterIcon}
        alt="message-center"
        style={{ width: 18, height: 18, cursor: 'pointer' }}
        onClick={() => {
          setMessageCenterOpen(true);
        }}
      />
      {unreadCount > 0 && (
        <div
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            minWidth: 18,
            height: 18,
            backgroundColor: '#ff4d4f',
            borderRadius: '9px',
            border: '1px solid white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 6px',
            fontSize: '10px',
            color: 'white',
            fontWeight: 'bold',
          }}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </div>
      )}
      {messageCenterOpen && (
        <MessageCenter
          open={messageCenterOpen}
          unreadCount={unreadCount}
          handleClose={async () => {
            setMessageCenterOpen(false);

          }}
        />
      )}
    </div>
  );
};
